// extracted by mini-css-extract-plugin
export default {"text":"x8aeVYJ8iGvpdyb1Ux5b","clamped":"X5lzBJe1ljYtMBu_jBLo","toggle":"eQdKOiO40fuf4U6ohnyv"};